import createQueryStore from './createQueryStore';

const store = createQueryStore('subscriptionDiscount');

export default store.reducer;
export const actions = store.actions;
export const useDiscountStore = store.useStore;
